export default "/images/fast_company.svg?5892c5347d74474efc0f54986aa1b64d";